const truncateText = ({
  text,
  maxTextSize
}) => {
  const wrapper = document.createElement("div");
  const cleanedText = text.replace(/[\n\r\t]+/g, "").replace(/>\s+</g, "><").replace(/\s{2,}/g, " ").trim();
  wrapper.innerHTML = cleanedText;
  let textContent = wrapper.textContent || wrapper.innerText || "";
  let orginalString = textContent;
  textContent = textContent.slice(0, maxTextSize);
  const walkAndReplace = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      let newText = textContent.slice(0, node.nodeValue.length);
      textContent = textContent.slice(node.nodeValue.length);
      node.nodeValue = `${newText}`;
    } else {
      node.childNodes.forEach(walkAndReplace);
    }
  };
  walkAndReplace(wrapper);
  if (orginalString.length > maxTextSize) {
    const lastChild = wrapper.children[wrapper.children.length - 1];
    if (lastChild) {
      lastChild.innerHTML = lastChild.innerHTML + " ...";
    } else {
      wrapper.innerHTML += " ...";
    }
  }
  return wrapper.innerHTML;
};
export {
  truncateText
};
//# sourceMappingURL=truncateText.js.map
